import { PayloadMoveAvtivityType, ResponseMutationActivityType } from 'components/types/company/activityType';
import { http } from 'helpers/http';

const URL = process.env.REACT_APP_API;
const URL_V2 = process.env.REACT_APP_API_V2;

export const apiActivityType = {
  activityTypeList: 'wla/list-activity-type',
  createActivityType: 'wla/create-activity-type',
  updateActivityType: 'wla/update-activity-type',
  moveActivityType: 'wla/move-activity-type',
};

export const activityTypeService = {
  getSkillGroup: async (): Promise<any> => {
    const response = await http.post(`${URL}${apiActivityType.activityTypeList}`);

    return response.data?.data ?? response.data;
  },

  createActivityType: async (payload: any): Promise<ResponseMutationActivityType> => {
    const response = await http.post(`${URL}${apiActivityType.createActivityType}`, payload);

    return response.data;
  },

  updateActivityType: async (payload: any): Promise<ResponseMutationActivityType> => {
    const response = await http.post(`${URL}${apiActivityType.updateActivityType}`, payload);

    return response.data;
  },

  moveActivityType: async (payload: PayloadMoveAvtivityType): Promise<ResponseMutationActivityType> => {
    const response = await http.post(`${URL}${apiActivityType.moveActivityType}`, payload);

    return response.data;
  },
};
